// Brittfurn rum: kontosidans Rumsvisualisering-flik. Listar kundens sparade rum och öppnar
// rumsvisualiseringen som ett fullskärmsoverlay (som Textilstudion), inte en egen sida.
// No-op på sidor utan [data-bf-rooms-list].

import { t, tn } from '~/studio/lib/i18n.js';

(function () {
  const list = document.querySelector('[data-bf-rooms-list]');
  if (!list) return;

  const BACKEND = (document.querySelector('meta[name="bf-backend-url"]') || {}).content
    || 'https://backend-sam-8064s-projects.vercel.app';

  function authHeaders(extra) {
    const h = Object.assign({}, extra);
    try {
      const t = localStorage.getItem('bf_token');
      if (t) h.Authorization = 'Bearer ' + t;
    } catch {}
    return h;
  }
  function tokenReady() {
    try { if (localStorage.getItem('bf_token')) return Promise.resolve(); } catch {}
    if (!window.bfCustomerBootstrap) return Promise.resolve();
    return new Promise((resolve) => {
      let done = false;
      const fin = () => { if (!done) { done = true; resolve(); } };
      document.addEventListener('bf:account-ready', fin, { once: true });
      setTimeout(fin, 3000);
    });
  }
  function api(path, options = {}) {
    return fetch(BACKEND + path, {
      credentials: 'include',
      ...options,
      headers: authHeaders({ 'Content-Type': 'application/json', ...(options.headers || {}) }),
    }).then(async (r) => {
      const t = await r.text();
      let body; try { body = JSON.parse(t); } catch { body = { raw: t }; }
      if (!r.ok) throw Object.assign(new Error(body.error || r.statusText), { status: r.status });
      return body;
    });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  }
  function photoUrl(src) {
    if (!src) return '';
    return src.startsWith('//') ? 'https:' + src : src;
  }

  // ---- fullskärmsoverlay (samma mönster som bf-textilstudio.js) ----
  function makeOverlay() {
    const ov = document.querySelector('[data-wpv-overlay]');
    if (!ov) return null;
    const content = ov.querySelector('[data-wpv-overlay-content]');
    const closeBtn = ov.querySelector('[data-wpv-overlay-close]');
    let mounted = null;
    let dirty = false; // rum skapades/ändrades → uppdatera listan vid stängning

    function mountStudio(params) {
      return new Promise((resolve, reject) => {
        const go = () => {
          try { resolve(window.bfWallpaperStudio.mountConfigurator(content, params, {})); }
          catch (e) { reject(e); }
        };
        if (window.bfWallpaperStudio && window.bfWallpaperStudio.mountConfigurator) return go();
        let settled = false;
        const onReady = () => {
          if (settled) return;
          settled = true;
          document.removeEventListener('bf-wallpaper-studio:ready', onReady);
          go();
        };
        document.addEventListener('bf-wallpaper-studio:ready', onReady);
        setTimeout(() => {
          if (settled) return;
          settled = true;
          document.removeEventListener('bf-wallpaper-studio:ready', onReady);
          if (window.bfWallpaperStudio && window.bfWallpaperStudio.mountConfigurator) go();
          else reject(new Error('wallpaper bundle not loaded'));
        }, 8000);
      });
    }
    function open(roomId) {
      dirty = true; // en session i studion kan skapa/ändra rum
      ov.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
      if (mounted) { mounted.unmount(); mounted = null; }
      content.innerHTML = '<div class="bf-ts-overlay__placeholder">' + esc(t('hub.loading')) + '</div>';
      const params = {
        customer: {
          id: ov.dataset.customerId || '',
          email: ov.dataset.customerEmail || '',
          name: ov.dataset.customerName || ''
        },
        room: roomId || ''
      };
      mountStudio(params)
        .then((h) => { mounted = h; })
        .catch(() => { content.innerHTML = '<div class="bf-ts-overlay__placeholder">' + esc(t('hub.rooms_visualizer_error')) + '</div>'; });
    }
    function close() {
      ov.hidden = true;
      document.documentElement.style.overflow = '';
      if (mounted) { mounted.unmount(); mounted = null; }
      if (dirty) { dirty = false; load(); } // återspegla nya/ändrade rum
    }
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !ov.hidden) close(); });
    return { open, close };
  }
  const overlay = makeOverlay();
  function openStudio(roomId) {
    if (overlay) overlay.open(roomId);
    else window.location.href = '/pages/visualisering' + (roomId ? '?room=' + encodeURIComponent(roomId) : '');
  }

  // Same filled-heart mark as the Textilstudio cards; here it removes the saved room.
  const HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 21s-7.5-4.6-10-9.2C.6 9 1.7 5.7 4.8 5.1 6.9 4.7 8.8 6 12 8.6 15.2 6 17.1 4.7 19.2 5.1c3.1.6 4.2 3.9 2.8 6.7C19.5 16.4 12 21 12 21Z"/></svg>';

  const countEl = document.querySelector('[data-bf-rooms-count]');
  function setCount(n) { if (countEl) countEl.textContent = n ? '(' + n + ')' : ''; }

  // Hero "Starta ny visualisering" pill opens the studio with no preselected room.
  document.querySelectorAll('[data-bf-rooms-new]').forEach((b) =>
    b.addEventListener('click', () => openStudio(''))
  );

  const SKELETON = '<div class="bf-ts-grid bf-ts-skeleton" aria-hidden="true"><span></span><span></span><span></span></div>';

  async function load() {
    list.innerHTML = SKELETON;
    try {
      await tokenReady();
      const { rooms } = await api('/api/rooms');
      setCount(rooms ? rooms.length : 0);
      if (!rooms || rooms.length === 0) {
        list.innerHTML = `
          <div class="bf-ts-empty">
            <h4 class="bf-ts-empty__title">${esc(t('hub.rooms_empty_title'))}</h4>
            <p class="bf-ts-empty__body">${esc(t('hub.rooms_empty_body'))}</p>
            <button type="button" class="bf-ts-btn bf-ts-btn--primary" data-bf-rooms-new-inline>${esc(t('hub.rooms_upload'))}</button>
          </div>`;
        const nb = list.querySelector('[data-bf-rooms-new-inline]');
        if (nb) nb.addEventListener('click', () => openStudio(''));
        return;
      }
      const grid = document.createElement('div');
      grid.className = 'bf-ts-grid';
      for (const room of rooms) {
        const wallCount = Array.isArray(room.walls) ? room.walls.length : 0;
        const cover = photoUrl(room.photo_url);
        const name = room.name || t('hub.room_default_name');
        const card = document.createElement('article');
        card.className = 'bf-ts-card bf-ts-card--combo';
        card.setAttribute('role', 'button');
        card.setAttribute('tabindex', '0');
        card.setAttribute('aria-label', t('hub.open_room', { name }));
        card.innerHTML = `
          <div class="bf-ts-card__media">
            ${cover ? `<img src="${esc(cover)}" alt="${esc(name)}" loading="lazy">` : '<div class="bf-ts-card__ph"></div>'}
            <button type="button" class="bf-ts-heart is-on" data-remove="${esc(room.id)}" aria-pressed="true" aria-label="${esc(t('hub.remove_room'))}">${HEART}</button>
          </div>
          <div class="bf-ts-card__body">
            <h3 class="bf-ts-card__title">${esc(name)}</h3>
            <p class="bf-ts-card__sub">${esc(tn('hub.wall_count', wallCount))}</p>
          </div>`;
        const openRoom = (e) => { if (e.target.closest('[data-remove]')) return; openStudio(room.id); };
        card.addEventListener('click', openRoom);
        card.addEventListener('keydown', (e) => {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          if (e.target.closest('[data-remove]')) return;
          e.preventDefault();
          openStudio(room.id);
        });
        card.querySelector('[data-remove]').addEventListener('click', async (e) => {
          e.stopPropagation();
          if (!window.confirm(t('hub.confirm_remove_room'))) return;
          card.classList.add('bf-ts-card--out');
          setTimeout(() => card.remove(), 200);
          const left = grid.children.length - 1;
          setCount(left);
          if (left <= 0) load();
          try { await api('/api/rooms/' + encodeURIComponent(room.id), { method: 'DELETE' }); }
          catch (err) { load(); }
        });
        grid.appendChild(card);
      }
      list.innerHTML = '';
      list.appendChild(grid);
    } catch (e) {
      list.innerHTML = `
        <div class="bf-ts-inline-error">
          <span>${esc(t('hub.rooms_error'))}</span>
          <button type="button" class="bf-ts-btn bf-ts-btn--ghost" data-bf-rooms-retry>${esc(t('hub.retry'))}</button>
        </div>`;
      const rb = list.querySelector('[data-bf-rooms-retry]');
      if (rb) rb.addEventListener('click', load);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load);
  else load();
})();
